import { IsIn, IsNotEmpty, IsString, MaxLength } from 'class-validator';
import { LeadSourceType } from '../enums/leads';

export class SaveLeadSourceDto {
  @IsIn([LeadSourceType.EMAIL, LeadSourceType.PHONE])
  sourceType: LeadSourceType.EMAIL | LeadSourceType.PHONE;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  sourceValue: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  source2Name: string;

  @IsString()
  @MaxLength(255)
  source2Subject: string;

  @IsString()
  @MaxLength(16000)
  source2template: string;
}

export class LeadSourceConfigDto extends SaveLeadSourceDto {
  id: number;
}

export class LeadSourceOptionsDto {
  emails: string[];
  phones: string[];
}

export class LeadSourceChoiceDto {
  id: number;
  sourceType: LeadSourceType;
  source2Name: string;
}
